import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Popover, Box } from '@mui/material'
import '../../../../../style/filters.css'

const StatusFilter = ({ filterList, onChange, index, column, filterOptions }) => {
  const [tempFilters, setTempFilters] = useState(filterList || [])
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleChange = (event) => {
    const { value, checked } = event.target
    setTempFilters((prev) => (checked ? [...prev, value] : prev.filter((item) => item !== value)))
  }

  const handleApply = () => {
    const cleaned = tempFilters.filter(Boolean)
    onChange(cleaned, index, column)
    handleClose()
  }

  const handleReset = () => {
    setTempFilters([])
    onChange([], index, column)
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'status-filter-popover' : undefined

  useEffect(() => {
    if (open) {
      setTempFilters(filterList || [])
    }
  }, [open, filterList])

  const getStatusStyle = (status) => {
    const baseStyle = {
      fontSize: 12,
      fontWeight: 'normal',
      padding: '5px 10px',
      borderRadius: 5,
      display: 'inline-block',
      textTransform: 'uppercase',
      minWidth: '90px',
      textAlign: 'center',
    }

    switch (String(status).toLowerCase()) {
      case 'open':
        return { ...baseStyle, backgroundColor: '#e74c3c', color: '#ffffff' }
      case 'in progress':
        return { ...baseStyle, backgroundColor: '#3498db', color: '#ffffff' }
      case 'resolved':
        return { ...baseStyle, backgroundColor: '#2ecc71', color: '#ffffff' }
      case 'on hold':
        return { ...baseStyle, backgroundColor: '#f39c12', color: '#ffffff' }
      default:
        return { ...baseStyle, backgroundColor: '#95a5a6', color: '#ffffff' }
    }
  }

  return (
    <div>
      <Button
        aria-describedby={id}
        onClick={handleClick}
        variant="outlined"
        size="small"
        style={{
          marginLeft: 8,
          borderColor: filterList?.length > 0 ? '#1976d2' : '',
          backgroundColor: filterList?.length > 0 ? 'rgba(25, 118, 210, 0.08)' : '',
        }}
      >
        Status Filter
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            backgroundColor: '#424242',
            color: '#ffffff',
            padding: '16px',
            width: '300px',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <div className="filter-title">Status Filters</div>
          <div style={{ maxHeight: '300px', overflow: 'auto', marginBottom: '16px' }}>
            {filterOptions.statuses?.map((status, i) => {
              const style = getStatusStyle(status)
              return (
                <div key={i} style={{ display: 'flex', alignItems: 'center', margin: '6px 0' }}>
                  <Checkbox
                    checked={tempFilters.includes(status)}
                    onChange={handleChange}
                    value={status}
                    size="small"
                    style={{ color: '#ffffff' }}
                  />
                  <span style={{ ...style, marginLeft: '8px' }}>{status}</span>
                </div>
              )
            })}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={handleReset} className="reset-button-filter">
              Reset
            </button>
            <button onClick={handleApply} className="apply-button-filter">
              Apply
            </button>
          </div>
        </Box>
      </Popover>
    </div>
  )
}

export default StatusFilter
